import { render, staticRenderFns } from "./userProfileInfo.vue?vue&type=template&id=24593148&scoped=true&"
import script from "./userProfileInfo.vue?vue&type=script&lang=js&"
export * from "./userProfileInfo.vue?vue&type=script&lang=js&"
import style0 from "./userProfileInfo.vue?vue&type=style&index=0&id=24593148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24593148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VLayout,VRow})
